// Ports ApproachView from Rev9 Site.html.

import { useNavigate } from 'react-router-dom';

import { MarketingLayout } from '../../components/marketing-shell';

export default function Approach() {
  const navigate = useNavigate();
  return (
    <MarketingLayout>
      <main className="view">
        <section style={{ padding: '120px 0 var(--pad-y)', borderBottom: 'var(--hairline)' }}>
          <div className="container">
            <div className="section-head">
              <span className="kicker">02 · METHOD</span>
              <h1 className="section-title">How we <em>manage capital.</em></h1>
            </div>

            <p className="serif-body" style={{ fontStyle: 'italic', maxWidth: '52ch', fontSize: 24 }}>
              <em>The Rev9 approach</em> is built on three commitments: discretion, transparency, and discipline. Each one is operational, not aspirational.
            </p>
          </div>
        </section>

        <section className="section">
          <div className="container">
            <div className="commits">
              <div className="commit">
                <span className="commit-kicker">A · DISCRETION</span>
                <p>
                  Each client has their own account, in their own name or in a segregated company sub-account. <em>Funds are never pooled.</em> Performance is calculated and reported per account.
                </p>
              </div>
              <div className="commit">
                <span className="commit-kicker">B · TRANSPARENCY</span>
                <p>
                  Every position, every trade, every fee. Snapshots reconciled against venue records daily. <em>Monthly statements are immutable</em> — once issued, they are a fixed record. Errors, if found, are corrected by new statements that supersede, not replace, the original.
                </p>
              </div>
              <div className="commit">
                <span className="commit-kicker">C · DISCIPLINE</span>
                <p>
                  Mid-period deposits are held in cash and applied at the start of the next monthly period. Withdrawals are processed at period close. <em>This structure produces clean monthly accounting</em> and removes the noise of mid-period capital flows from performance attribution.
                </p>
              </div>
            </div>

            <div className="methodology">
              <h4>METHODOLOGY</h4>
              <ul>
                <li><span className="n">M1</span><span>Time-weighted returns at the period level.</span></li>
                <li><span className="n">M2</span><span>FIFO cost basis.</span></li>
                <li><span className="n">M3</span><span>Mark-to-market via venue spot prices at 00:00 UTC daily.</span></li>
              </ul>
            </div>

            <div style={{
              marginTop: 96, paddingTop: 32, borderTop: '1px solid var(--ink)',
              display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 24,
            }}>
              <p className="serif-body" style={{ margin: 0, fontSize: 24, maxWidth: '40ch' }}>
                Considering Rev9 for managed digital asset exposure?
              </p>
              <button className="btn" onClick={() => navigate('/contact')}>
                Contact us <span className="btn-arrow">→</span>
              </button>
            </div>
          </div>
        </section>
      </main>
    </MarketingLayout>
  );
}
